import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {UpdateBasicCompanyDataPayload} from '../../actions/companyCommand';
import Event from '../../actions/event';
import Api from '../../../api';

const onUpdateBasicCompanyData = function*(data: UpdateBasicCompanyDataPayload) {
    // Step 1: Save base data + test category
    try {
        const payload: any = {
            companyId: data.companyId,
            restaurantName: data.restaurantName,
            companyName: data.companyName,
            billingStreet: data.billingStreet,
            billingZip: data.billingZip,
            billingCity: data.billingCity,
            contactPerson: data.contactPerson,
            street: data.street,
            zip: data.zip,
            city: data.city,
            phone: data.phone,
            email: data.email,
            web: data.web,
            hidden: Boolean(data.hidden),
            travelRegion: data.travelRegion,
            bookedQualityCheck: Boolean(data.bookedQualityCheck),
            bookedQualityCheckDate: data.bookedQualityCheckDate,
            bookedMarketing: Boolean(data.bookedMarketing),
            bookedMarketingDate: data.bookedMarketingDate,
        };

        if (data.hospitality) {
            payload.hospitality = data.hospitality;
        }

        yield call(Api.Command.updateBasicCompanyData, payload);

        if (data.testCategory) {
            yield call(Api.Command.setCompanyTestCategory, {
                companyId: data.companyId,
                testCategory: data.testCategory,
            });
        }

        const { versionedBooking: _vb, ...baseData } = data;
        yield put(Event.Company.basicCompanyDataUpdated({
            ...baseData,
        }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Die Stammdaten konnten nicht aktualisiert werden.',
        }));
        return;
    }

    // Step 2: Handle versioned booking sequentially AFTER base data is saved
    if (data.versionedBooking) {
        const vb = data.versionedBooking;
        try {
            yield call(Api.Command.bookCompanyForVersion, {
                companyId: data.companyId,
                version: vb.version,
                bookedQualityCheck: vb.bookedQualityCheck,
                bookedQualityCheckDate: vb.bookedQualityCheckDate,
                bookedMarketing: vb.bookedMarketing,
                bookedMarketingDate: vb.bookedMarketingDate,
            });

            yield put(Event.Company.companyBookingAdded({
                companyId: data.companyId,
                version: vb.version,
                qualityCheck: vb.bookedQualityCheck,
                qualityCheckDate: vb.bookedQualityCheckDate,
                marketing: vb.bookedMarketing,
                marketingDate: vb.bookedMarketingDate,
            }));
        } catch (e) {
            yield put(Command.Notification.enqueueNotification({
                severity: 'warning',
                message: 'Stammdaten gespeichert, aber die Buchung konnte nicht'
                    + ' aktualisiert werden. Bitte erneut versuchen.',
            }));
            return;
        }
    }

    if (data.hidden) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: 'Das Unternehmen wurde ausgeblendet.',
        }));
    } else {
        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: 'Die Stammdaten wurden aktualisiert.',
        }));
    }
};

export function* updateBasicCompanyDataFlow() {
    while (true) {
        const action: Action<UpdateBasicCompanyDataPayload> = yield take(
            Command.Company.updateBasicCompanyData.toString(),
        );

        yield fork(onUpdateBasicCompanyData, action.payload);
    }
}
